import React from "react";

const MAP = {
  abierta: { plazas: { label: "Plazas disponibles", cls: "bg-emerald-100 text-emerald-700" } },
};

export function StatusBadge({ activity, size = "sm" }) {
  let label = "Plazas disponibles";
  let cls = "bg-emerald-100 text-emerald-700";
  if (activity.status === "cancelada") {
    label = "Cancelada";
    cls = "bg-red-100 text-[#E31837]";
  } else if (activity.inscriptions_closed) {
    label = "Inscripciones cerradas";
    cls = "bg-slate-200 text-slate-600";
  } else if (activity.is_full) {
    label = "Completa · Lista de espera";
    cls = "bg-slate-800 text-white";
  } else if (activity.capacity > 0 && activity.seats_available != null && activity.seats_available <= activity.capacity / 2) {
    label = "¡Casi completa!";
    cls = "bg-orange-100 text-[#FF7F27] animate-pulse";
  }
  const pad = size === "lg" ? "px-4 py-1.5 text-sm" : "px-3 py-1 text-xs";
  return (
    <span data-testid="status-badge" className={`inline-flex items-center gap-1.5 rounded-full font-bold ${pad} ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
